import { duration } from "moment";
import { ToastService } from "../../services/toast.service";
import { Injectable } from "@angular/core";
import { ResponseError } from "../../models/domains/pbm/response-error";

@Injectable({ providedIn: "root" })
export class Toast {
  constructor(private toastService: ToastService) { }

  showWarningToast(text: string, title: string = "Atenção", secondsDurantion: number = 7) {
    const type = "warning";
    this.toastService.show({ type, title, text, secondsDurantion });
  }

  showSuccessToast(text: string, title: string = "", secondsDurantion: number = 5) {
    const type = "success";
    this.toastService.show({ type, title, text, secondsDurantion });
  }

  showInfoToast(text: string, title: string = "", secondsDurantion: number = 1) {
    const type = "info";
    this.toastService.show({ type, title, text, secondsDurantion });
  }

  showResponseErrorToast(response: any) {
    const error = response.error?.Data
    this.showWarningToast((error?.ErrorMessage ?? error) as string)
  }

  showErrorToast(text: string, title: string = "Erro", secondsDurantion: number = 7) {
    const type = "error";
    this.toastService.show({ type, title, text, secondsDurantion });
  }
}
